import "../../styles/Pages/Conformaliter/CGV.css";

export default function CGV() {
  return (
    <div className="cgv-page">
      <header className="cgv-hero">
        <h1>CONDITIONS GÉNÉRALES DE VENTE (CGV)</h1>
        <h2>VERTYNO</h2>
        <p className="cgv-intro">
          Les présentes Conditions Générales de Vente (ci-après les « CGV ») régissent la vente des produits proposés par la société VERTYNO (ci-après le « Vendeur ») sur son site internet (ci-après le « Site »).
        </p>
        <p className="cgv-intro">
          Toute commande passée sur le Site implique l'acceptation pleine et entière des présentes CGV, sans réserve, par le client (ci-après le « Client »).
        </p>
        <p className="cgv-update">Dernière mise à jour : {new Date().toLocaleDateString()}</p>
      </header>

      {/* Sommaire */}
      <nav className="cgv-toc" aria-label="Sommaire">
        <ul>
          <li><a href="#champ-application">1. Champ d'application</a></li>
          <li><a href="#produits">2. Produits et disponibilité</a></li>
          <li><a href="#prix">3. Prix</a></li>
          <li><a href="#paiement">4. Paiement</a></li>
          <li><a href="#acceptation">5. Acceptation de la commande</a></li>
          <li><a href="#livraison">6. Livraison</a></li>
          <li><a href="#utilisation">7. Utilisation des produits</a></li>
          <li><a href="#retractation">8. Droit de rétractation</a></li>
          <li><a href="#remboursements">9. Remboursements</a></li>
          <li><a href="#garanties">10. Garanties légales</a></li>
          <li><a href="#responsabilite">11. Responsabilité</a></li>
          <li><a href="#donnees">12. Données personnelles</a></li>
          <li><a href="#litiges">13. Droit applicable et Litiges</a></li>
          <li><a href="#contact">14. Informations de contact</a></li>
        </ul>
      </nav>

      <main className="cgv-content">
        <section id="champ-application" className="cgv-block">
          <h2>1. Champ d'application</h2>
          <p>
            Les présentes CGV s'appliquent à toutes les commandes effectuées sur le Site par des consommateurs au sens du Code de la consommation. VERTYNO se réserve le droit de modifier les présentes CGV à tout moment. Les conditions applicables sont celles en vigueur à la date de la commande.
          </p>
        </section>

        <section id="produits" className="cgv-block">
          <h2>2. Produits et disponibilité</h2>
          <p>
            Les produits sont décrits et présentés avec la plus grande précision possible. Toutefois, des erreurs ou omissions peuvent survenir. Les produits sont proposés dans la limite des stocks disponibles. En cas d'indisponibilité après commande, l'acheteur en sera informé et pourra choisir entre un remboursement ou un produit équivalent. Les produits vendus sont destinés à un usage personnel et licite.
          </p>
        </section>

        <section id="prix" className="cgv-block">
          <h2>3. Prix</h2>
          <p>
            Les prix affichés sur le Site sont indiqués en <strong>euros (€)</strong> et s'entendent toutes taxes comprises (TTC). VERTYNO se réserve le droit de modifier ses prix à tout moment, mais les produits seront facturés sur la base des tarifs en vigueur au moment de la validation de la commande.
          </p>
        </section>

        <section id="paiement" className="cgv-block">
          <h2>4. Paiement</h2>
          <p>
            Le paiement est exigible immédiatement à la commande. Les paiements sont sécurisés. Les moyens de paiement acceptés sont :
          </p>
          <ul>
            <li>Visa, Mastercard, American Express</li>
            <li>Apple Pay</li>
            <li>PayPal</li>
          </ul>
          <p>
            La commande ne sera considérée comme définitive qu'après confirmation du paiement et envoi d'un email de confirmation au Client. VERTYNO se réserve le droit de refuser toute commande en cas de suspicion de fraude ou de litige de paiement antérieur.
          </p>
          <p>
            La commande est réputée validée après confirmation du paiement.
          </p>
        </section>

        <section id="acceptation" className="cgv-block">
          <h2>5. Acceptation de la commande</h2>
          <p>
            Une commande n'est considérée comme acceptée qu'après l'envoi d'un <strong>email de confirmation</strong>.
          </p>
          <p>
            VERTYNO se réserve le droit de refuser ou d'annuler toute commande en cas de :
          </p>
          <ul>
            <li>suspicion de fraude,</li>
            <li>incohérence des informations fournies,</li>
            <li>commande anormale ou abusive,</li>
            <li>litige antérieur non résolu.</li>
          </ul>
          <p>
            Le client est informé de tout refus ou annulation par email.
          </p>
        </section>

        <section id="livraison" className="cgv-block">
          <h2>6. Livraison</h2>
          <p><strong>Zones de livraison :</strong> Les livraisons sont effectuées en France métropolitaine et dans l'ensemble des pays de l'Union européenne.</p>
          <p>
            VERTYNO livre :
          </p>
          <ul>
            <li>en <strong>France métropolitaine</strong>,</li>
            <li>dans <strong>l'ensemble des pays de l'Union européenne</strong>.</li>
          </ul>
          <p><strong>Délais et expédition :</strong></p>
          <ul>
            <li>Traitement avant expédition : <strong>1 à 2 jours ouvrés</strong>.</li>
            <li>Livraison après expédition : <strong>2 à 5 jours ouvrés</strong>.</li>
            <li>Délai total estimé : <strong>3 à 7 jours ouvrés</strong>.</li>
          </ul>
          <p>
            Ces délais sont donnés à titre indicatif. VERTYNO ne saurait être tenu responsable des retards de livraison imputables aux services de transport ou en cas de force majeure.
          </p>
          <p>
            Ces délais sont indicatifs et peuvent être prolongés en cas de circonstances exceptionnelles indépendantes de la volonté de VERTYNO (grèves, conditions météorologiques, incidents logistiques).
          </p>
        </section>

        <section id="utilisation" className="cgv-block">
          <h2>7. Utilisation des produits</h2>
          <p>
            Les produits vendus sont destinés à un usage personnel et licite.
          </p>
          <p>
            Toute utilisation frauduleuse, trompeuse ou contraire à la loi est strictement interdite.
          </p>
        </section>

        <section id="retractation" className="cgv-block">
          <h2>8. Droit de rétractation</h2>
          <p>
            Conformément aux articles L221-18 et suivants du Code de la consommation, le Client dispose d'un délai de <strong>14 jours calendaires</strong> à compter de la réception du produit pour exercer son droit de rétractation, sans avoir à justifier de motif.
          </p>
          <p><strong>Procédure de retour :</strong> Pour exercer ce droit, le Client doit contacter le service client à : <a href="mailto:contact@vertyno.com" className="cgv-link">contact@vertyno.com</a>. Le produit doit être retourné :</p>
          <ul>
            <li>Neuf, non utilisé et non endommagé.</li>
            <li>Dans son emballage d'origine.</li>
          </ul>
          <p>
            Les frais de retour sont à la charge du Client, sauf en cas d'erreur de la part de VERTYNO.
          </p>
        </section>

        <section id="remboursements" className="cgv-block">
          <h2>9. Remboursements</h2>
          <p>
            Une fois le produit retourné reçu et inspecté, le remboursement sera effectué sous <strong>5 jours ouvrés</strong> via le mode de paiement utilisé lors de la commande initiale. Tout produit retourné incomplet, abîmé ou sali ne sera pas remboursé.
          </p>
          <p>
            Après réception et inspection du produit retourné, le remboursement est effectué <strong>sous 5 jours ouvrés</strong>, via le mode de paiement utilisé lors de la commande.
          </p>
          <p>
            Tout produit ne respectant pas les conditions de retour pourra faire l'objet d'un <strong>refus de remboursement</strong>.
          </p>
          <p>
            En cas de suspicion de fraude, VERTYNO se réserve le droit de différer le remboursement le temps des vérifications nécessaires.
          </p>
        </section>

        <section id="garanties" className="cgv-block">
          <h2>10. Garanties légales</h2>
          <p>
            Indépendamment du droit de rétractation, nos produits bénéficient de la <strong>garantie légale de conformité</strong> (articles L.217-4 et suivants du Code de la consommation) et de la garantie contre les vices cachés (articles 1641 et suivants du Code civil). En cas de produit défectueux ou non conforme, merci de nous contacter à <a href="mailto:contact@vertyno.com" className="cgv-link">contact@vertyno.com</a> avec une description du problème et, si possible, des photos.
          </p>
        </section>

        <section id="responsabilite" className="cgv-block">
          <h2>11. Responsabilité</h2>
          <p>
            La responsabilité de VERTYNO ne saurait être engagée en cas de mauvaise utilisation des produits achetés, de modification du produit par le Client, ou pour tout dommage résultant d'une cause étrangère au produit. La responsabilité de VERTYNO est limitée au montant de la commande.
          </p>
          <p>
            VERTYNO ne saurait être tenu responsable :
          </p>
          <ul>
            <li>des retards imputables aux transporteurs,</li>
            <li>des erreurs d'adresse fournies par le client,</li>
            <li>de l'utilisation non conforme des produits.</li>
          </ul>
          <p>
            La responsabilité de VERTYNO est limitée au <strong>montant de la commande</strong>.
          </p>
        </section>

        <section id="donnees" className="cgv-block">
          <h2>12. Données personnelles</h2>
          <p>
            Les informations collectées lors des commandes sont nécessaires à la gestion de la transaction et sont traitées conformément à notre politique de confidentialité et au Règlement Général sur la Protection des Données (RGPD). Le Client dispose d'un droit d'accès, de rectification et de suppression de ses données.
          </p>
        </section>

        <section id="litiges" className="cgv-block">
          <h2>13. Droit applicable et Litiges</h2>
          <p>
            Les présentes CGV sont soumises au <strong>droit français</strong>. En cas de litige, une solution amiable sera recherchée en priorité. Le Client est invité à contacter le service client. Conformément à la loi, le consommateur peut également recourir gratuitement à un médiateur de la consommation. À défaut d'accord amiable, les tribunaux français seront seuls compétents.
          </p>
          <p>
            En cas de litige, le client est invité à contacter préalablement le service client afin de rechercher une solution amiable.
          </p>
          <p>
            Conformément à la loi, le consommateur peut recourir à un <strong>médiateur de la consommation</strong>.
          </p>
        </section>

        <section id="contact" className="cgv-block">
          <h2>14. Informations de contact (Mentions Légales)</h2>
          <p>
            <strong>VERTYNO – SASU</strong>
          </p>
          <p>
            📍 9 Allée Gabriel Zirnhelt, 93110 Rosny-sous-Bois<br />
            📧 <a href="mailto:contact@vertyno.com" className="cgv-link">contact@vertyno.com</a><br />
            📞 06 61 05 05 71<br />
            <strong>Service client :</strong> du lundi au vendredi, horaires de bureau.
          </p>
        </section>
      </main>
    </div>
  );
}
